<template>
  <div class="login">
    <fm-head title="登录"></fm-head>
    <div class="form">
      <van-cell-group :border="false">
        <van-field
          v-model="email"
          required
          clearable
          label="邮箱"
          placeholder="@hunliji.com"
        />

        <van-field
          v-model="password"
          type="password"
          required
          clearable
          label="密码"
          placeholder="请输入密码"
        />
      </van-cell-group>

      <van-button
        class="form__btn"
        type="primary"
        size="large"
        @click="onLogin"
      >登录</van-button>

      <van-button
        v-if="isRegistry"
        class="form__btn"
        type="default"
        size="large"
        @click="onRegistry"
      >注册</van-button>

      <van-button
        class="form__btn"
        type="default"
        size="large"
        @click="onLogout"
      >登出</van-button>
    </div>

    <copyright></copyright>
  </div>
</template>

<script>
import { CellGroup, Field, Cell, Button } from 'vant'
import Head from '@/components/Head'
import Copyright from '@/components/Copyright'
import api from '@/api'

export default {
  name: 'Login',
  components: {
    'fm-head': Head,
    'copyright': Copyright,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Button.name]: Button,
  },
  props: {},
  data () {
    return {
      email: '',
      password: '',
      isRegistry: false
    }
  },
  methods: {
    async onLogin() {
      const { email, password } = this
      if (!email) {
        this.$toast('邮箱错误')
      }
      if (!password) {
        this.$toast('密码不能为空')
      }
      const res = await api.login({ email, password })
      if (res.code === 0) {
        this.$toast('登录成功')
        const { redirect } = this.$route.query
        if (redirect) {
          this.$router.replace({
            name: redirect
          })
        }
      } else {
        this.$toast(res.data)
      }
    },
    async onRegistry() {
      const { email, password } = this
      if (!email) {
        this.$toast('邮箱错误')
      }
      if (!password) {
        this.$toast('密码不能为空')
      }
      const res = await api.registry({ email, password })
      if (res.code === 0) {
        this.$toast('注册成功')
      } else {
        this.$toast(res.data)
      }
    },
    async onLogout() {
      await api.logout()
    }
  },
  created () {
    this.isRegistry = this.$route.query.registry || false
  }
}
</script>

<style lang="less" scoped>
.login {
  margin: 0 auto;
  max-width: 400px;
}
.form {
  padding: 100px 20px;
  &__btn {
    margin-top: 40px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/login/index.vue